/* eslint-disable import/prefer-default-export */
import * as ReduxHelpers from '@src/utils/reduxHelpers'
const prefix = 'cam/monitoring'
// Action Types
export const GET_MONITORING_LIST_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_MONITORING_LIST_SUCCESS'
)
export const GET_MONITOR_INFO_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_MONITOR_INFO_SUCCESS'
)
export const CLEANER_STAT = ReduxHelpers.Types.createActionType(
  prefix,
  'CLEANER_STAT'
)
export const GET_MONITORING_LIST_FAIL = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_MONITORING_LIST_FAIL'
)
export const REQUEST_PENDING = ReduxHelpers.Types.createActionType(
  prefix,
  'REQUEST_PENDING'
)
export const DELETE_MONITOR_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'DELETE_MONITOR_SUCCESS'
)
export const DELETE_MONITOR_FAIL = ReduxHelpers.Types.createActionType(
  prefix,
  'DELETE_MONITOR_FAIL'
)
export const CREATE_MONITOR_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'CREATE_MONITOR_SUCCESS'
)
export const CREATE_MONITOR_FAIL = ReduxHelpers.Types.createActionType(
  prefix,
  'CREATE_MONITOR_FAIL'
)
export const UPDATE_MONITOR_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'UPDATE_MONITOR_SUCCESS'
)
export const UPDATE_MONITOR_FAIL = ReduxHelpers.Types.createActionType(
  prefix,
  'UPDATE_MONITOR_FAIL'
)
export const GET_MONITORS_COUNT = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_MONITORS_COUNT'
)
export const SHOW_ONLY_ENABLED_GUARDRAILS = ReduxHelpers.Types.createActionType(
  prefix,
  'SHOW_ONLY_ENABLED_GUARDRAILS'
)
